
import React, { Component } from "react";
import iconFind from "../../../assets/images/icons/find.png";

export interface IconFindProps
{
}

interface IconFindState 
{
}

export class IconFind extends Component<IconFindProps, IconFindState>
{
    constructor(props: IconFindProps)
    {
        super(props);

        this.state = {
        };
    }

    public render(): JSX.Element
    {
        return (
            <div className="icon">
                <img src={iconFind} alt="binoculars" style={{ maxWidth: "100%" }} />
            </div>
        );
    }
}